module.exports = __webpack_public_path__ + "img/lista.68a9d9d0.png";